import { CampaignModelMapper } from "features/campaign/domain/models/campaignModel";
import { formatCurrency } from "common/utils/currencyFormater";

export function validateWithdrawalAmount({
  value,
  withdrawalType,
  campaign,
  amountWithdrawable,
}: {
  value: string;
  withdrawalType?: string;
  campaign: CampaignModelMapper;
  amountWithdrawable: number;
}): string | undefined {
  const amount = Number.parseInt(value);

  if (isNaN(amount) || amount < 1) {
    return "Enter a valid amount.";
  }

  if (withdrawalType === "Partial") {
    const maxAllowed = Math.min(amountWithdrawable, campaign.balance);

    if (amount > maxAllowed) {
      return `Your withdrawal is capped at ${formatCurrency(maxAllowed, true)} based on your campaign's limit.`;
    }
  }

  if (withdrawalType === "Complete") {
    if (amount < campaign.balance) {
      return `You must withdraw your full balance.`;
    }

    if (amount > campaign.balance) {
      return `You can't withdraw more than your balance.`;
    }
  }

  return undefined;
}
